import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}

// // SERVICE WORKER REGISTRATION
// if ('serviceWorker' in navigator && environment.production) {
//   navigator.serviceWorker.register('firebase-messaging-sw.js').then((registration) => {
//     console.log('Service Worker registered with scope:', registration.scope);
//   }).catch((error) => {
//     console.error('Service Worker registration failed:', error);
//   });
// }

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));

document.addEventListener('click', function (e: MouseEvent) {

  const target = (e.target as HTMLElement).closest('.ripple') as HTMLElement;

  if (!target) return;

  const rect = target.getBoundingClientRect();

  const ripple = document.createElement('span');
  ripple.className = 'ripple-effect';

  const size = Math.max(rect.width, rect.height);

  ripple.style.width = ripple.style.height = `${size}px`;

  ripple.style.left = `${e.clientX - rect.left - size / 2}px`;
  ripple.style.top = `${e.clientY - rect.top - size / 2}px`;

  target.appendChild(ripple);

  setTimeout(() => {
    ripple.remove();
  }, 600);

});

